// types/familyAppointmentTypes.js
export const FAMILY_CREATE_APPOINTMENT_REQUEST = 'FAMILY_CREATE_APPOINTMENT_REQUEST';
export const FAMILY_CREATE_APPOINTMENT_SUCCESS = 'FAMILY_CREATE_APPOINTMENT_SUCCESS';
export const FAMILY_CREATE_APPOINTMENT_FAILURE = 'FAMILY_CREATE_APPOINTMENT_FAILURE';
export const FAMILY_RESET_APPOINTMENT_STATE = 'FAMILY_RESET_APPOINTMENT_STATE';